import {
  FETCH_INVENTORY,
  ADD_TEMPERATURE_TO_INVENTORY,
  FETCH_ITEMS,
  FETCH_BRANDS,
  FETCH_OFFERS,
  FETCH_GRADES,
  FETCH_WASTE_CATEGORIES,
  FETCH_LOCATIONS,
  FETCH_AUDITS,
  CREATE_AUDIT,
  FETCH_AUDIT,
  ADD_AUDIT_INVENTORY,
  REMOVE_AUDIT_INVENTORY,
  FETCH_INVENTORIES_RECALL,
} from "./types";

import { ITEMS_PER_PAGE } from "../../constants/constants";

const INITIAL_STATE = {
  inventoryDetail: {
    inventory: undefined,
    error: null,
    loading: false,
  },
  itemsList: {
    items: [],
    error: null,
    loading: true,
  },
  brandsList: {
    brands: [],
    error: null,
    loading: true,
  },
  offersList: {
    offers: [],
    error: null,
    loading: true,
  },
  gradesList: {
    grades: [],
    error: null,
    loading: true,
  },
  wasteCategoriesList: {
    categories: [],
    error: null,
    loading: true,
  },
  locationsList: {
    locations: [],
    error: null,
    loading: true,
  },
  inventoryAuditList: {
    audits: [],
    pages: null,
    loading: false,
    error: null,
  },
  inventoryAudit: {
    audit: null,
    loading: false,
    error: null,
  },
  inventoriesRecall: {
    inventories: [],
    pages: null,
    loading: false,
    error: null,
  },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_INVENTORY
    // --------------------------------------------------------------------------
    case FETCH_INVENTORY.init:
      return {
        ...state,
        inventoryDetail: { ...state.inventoryDetail, error: null, loading: true },
      };
    case FETCH_INVENTORY.success:
      return {
        ...state,
        inventoryDetail: { ...state.inventoryDetail, inventory: action.payload, error: null, loading: false },
      };
    case FETCH_INVENTORY.failure:
      return {
        ...state,
        inventoryDetail: {
          ...state.inventoryDetail,
          inventory: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // ADD_TEMPERATURE_TO_INVENTORY
    // --------------------------------------------------------------------------
    case ADD_TEMPERATURE_TO_INVENTORY:
      return {
        ...state,
        inventoryDetail: {
          ...state.inventoryDetail,
          inventory: {
            ...state.inventoryDetail.inventory,
            temperatures: [...state.inventoryDetail.inventory.temperatures, action.payload],
          },
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_ITEMS
    // --------------------------------------------------------------------------
    case FETCH_ITEMS.init:
      return {
        ...state,
        itemsList: { ...state.itemsList, items: [], loading: true },
      };
    case FETCH_ITEMS.success:
      return {
        ...state,
        itemsList: {
          items: action.payload.results,
          error: null,
          loading: false,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
        },
      };
    case FETCH_ITEMS.failure:
      return {
        ...state,
        itemsList: {
          ...state.itemsList,
          items: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
          pages: 1,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_BRANDS
    // --------------------------------------------------------------------------
    case FETCH_BRANDS.init:
      return {
        ...state,
        brandsList: { ...state.brandsList, brands: [], loading: true },
      };
    case FETCH_BRANDS.success:
      return {
        ...state,
        brandsList: {
          brands: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_BRANDS.failure:
      return {
        ...state,
        brandsList: { ...state.brandsList, brands: [], error: action.payload.data || { message: action.payload.message }, loading: false },
      };
    // --------------------------------------------------------------------------
    // FETCH_OFFERS
    // --------------------------------------------------------------------------
    case FETCH_OFFERS.init:
      return {
        ...state,
        offersList: { ...state.offersList, offers: [], loading: true },
      };
    case FETCH_OFFERS.success:
      return {
        ...state,
        offersList: {
          offers: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_OFFERS.failure:
      return {
        ...state,
        offersList: { ...state.offersList, offers: [], error: action.payload.data || { message: action.payload.message }, loading: false },
      };
    // --------------------------------------------------------------------------
    // FETCH_GRADES
    // --------------------------------------------------------------------------
    case FETCH_GRADES.init:
      return {
        ...state,
        gradesList: { ...state.gradesList, grades: [], loading: true },
      };
    case FETCH_GRADES.success:
      return {
        ...state,
        gradesList: {
          grades: action.payload,
          error: null,
          loading: false,
        },
      };
    case FETCH_GRADES.failure:
      return {
        ...state,
        gradesList: { ...state.gradesList, grades: [], error: action.payload.data || { message: action.payload.message }, loading: false },
      };
    // --------------------------------------------------------------------------
    // FETCH_WASTE_CATEGORIES
    // --------------------------------------------------------------------------
    case FETCH_WASTE_CATEGORIES.init:
      return {
        ...state,
        wasteCategoriesList: { ...state.wasteCategoriesList, categories: [], loading: true },
      };
    case FETCH_WASTE_CATEGORIES.success:
      return {
        ...state,
        wasteCategoriesList: {
          categories: action.payload.results,
          error: null,
          loading: false,
        },
      };
    case FETCH_WASTE_CATEGORIES.failure:
      return {
        ...state,
        wasteCategoriesList: {
          ...state.wasteCategoriesList,
          categories: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_LOCATIONS
    // --------------------------------------------------------------------------
    case FETCH_LOCATIONS.init:
      return {
        ...state,
        locationsList: { ...state.locationsList, locations: [], loading: true },
      };
    case FETCH_LOCATIONS.success:
      return {
        ...state,
        locationsList: {
          locations: action.payload.results,
          error: null,
          loading: false,
        },
      };
    case FETCH_LOCATIONS.failure:
      return {
        ...state,
        locationsList: {
          ...state.locationsList,
          locations: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_AUDITS
    // --------------------------------------------------------------------------
    case FETCH_AUDITS.init:
      return {
        ...state,
        inventoryAuditList: { ...state.inventoryAuditList, error: null, loading: true },
      };
    case FETCH_AUDITS.success:
      return {
        ...state,
        inventoryAuditList: {
          ...state.inventoryAuditList,
          audits: action.payload.results,
          pages: Math.ceil(action.payload.count / 2),
          error: null,
          loading: false,
        },
      };
    case FETCH_AUDITS.failure:
      return {
        ...state,
        inventoryAuditList: {
          ...state.inventoryAuditList,
          destinations: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // CREATE_AUDIT
    // --------------------------------------------------------------------------
    case CREATE_AUDIT.init:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, error: null, loading: true },
      };
    case CREATE_AUDIT.success:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, audit: action.payload.results, error: null, loading: false },
      };
    case CREATE_AUDIT.failure:
      return {
        ...state,
        inventoryAudit: {
          ...state.inventoryAudit,
          destinations: [],
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // FETCH_AUDIT
    // --------------------------------------------------------------------------
    case FETCH_AUDIT.init:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, error: null, loading: true },
      };
    case FETCH_AUDIT.success:
      let audit = action.payload;
      if (!audit.temporary_info) audit.temporary_info = [];
      audit.pages = Math.ceil(audit.temporary_info.length / ITEMS_PER_PAGE);
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, audit: audit, error: null, loading: false },
      };
    case FETCH_AUDIT.failure:
      return {
        ...state,
        inventoryAudit: {
          ...state.inventoryAudit,
          audit: null,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    // --------------------------------------------------------------------------
    // ADD_AUDIT_INVENTORY
    // --------------------------------------------------------------------------
    case ADD_AUDIT_INVENTORY.init:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, error: null, loading: true },
      };
    case ADD_AUDIT_INVENTORY.success:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, audit: action.payload, loading: false },
      };
    case ADD_AUDIT_INVENTORY.failure:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, error: action.payload, loading: false },
      };
    // --------------------------------------------------------------------------
    // REMOVE_AUDIT_INVENTORY
    // --------------------------------------------------------------------------
    case REMOVE_AUDIT_INVENTORY.init:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, error: null, loading: true },
      };
    case REMOVE_AUDIT_INVENTORY.success:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, audit: action.payload, loading: false },
      };
    case REMOVE_AUDIT_INVENTORY.failure:
      return {
        ...state,
        inventoryAudit: { ...state.inventoryAudit, error: action.payload, loading: false },
      };
    // --------------------------------------------------------------------------
    // FETCH_INVENTORIES_RECALL
    // --------------------------------------------------------------------------
    case FETCH_INVENTORIES_RECALL.init:
      return {
        ...state,
        inventoriesRecall: {
          ...state.inventoriesRecall,
          pages: undefined,
          error: null,
          loading: true,
        },
      };
    case FETCH_INVENTORIES_RECALL.success:
      return {
        ...state,
        inventoriesRecall: {
          ...state.inventoriesRecall,
          inventories: action.payload.results,
          pages: Math.ceil(action.payload.count / ITEMS_PER_PAGE),
          error: null,
          loading: false,
        },
      };
    case FETCH_INVENTORIES_RECALL.failure:
      return {
        ...state,
        inventoriesRecall: {
          ...state.inventoriesRecall,
          inventories: [],
          pages: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
